import { useMemo, useState } from "react"
import { usePreventHtmlScroll } from "../../hook"
import styled from "styled-components"
import { theme } from "../../styles/theme"
import { HistoryPeriodType } from "../../types"
// component
import { Section_History_Header } from "../../components/Section/History/Header"
import { Section_History_SafetyScore } from "../../components/Section/History/SafetyScore"
import { Section_History_PeriodAverage } from "../../components/Section/History/PeriodAverage"
import { Section_History_Calendar } from "../../components/Section/History/Calendar"
import { Section_History_DailyDrivings } from "../../components/Section/History/DailyDrivings"
import { Section_History_DrivingDetails } from "../../components/Section/History/DrivingDetails"
import { Section_History_Googlemap } from "../../components/Section/History/Googlemap"
// api
import { useGetHistoryCalcuCheck } from "../../api/history"
import { Section_History_Targets } from "../../components/Section/History/Targets"
import { useTodayState } from "../../components/Calendar/core"

export const HistoryPage = () => {
  usePreventHtmlScroll()
  const
  // state
  [deviceId, setDeviceId] = useState(0),
  [periodType, setPeriodType] = useState<HistoryPeriodType>("D"),
  [score, setScore] = useState<number | null>(null),
  [date, setDate] = useTodayState(),
  [drivingId, setDrivingId] = useState(0),
  // derived state
  {dailyDrivingListParams} = useMemo(() => {
    return {
      dailyDrivingListParams: {
        deviceId,
        schDate: date
      }
    }
  }, [deviceId, date]),
  {drivingDetailParams} = useMemo(() => {
    return {
      drivingDetailParams: {drivingId}
    }
  }, [drivingId]),
  // api
  {data: isAccessible, isLoading: isLoadingPage} = useGetHistoryCalcuCheck()

  const onEvent = (e: any) => {
    try {
      const {event, type, data} = e
      // console.log("❗❗❗ onEvent > ", e)

      switch (type) {
        case "listTarget": {
          const newDeviceId = data.target.device.id
          if (newDeviceId >= 0)
          if (newDeviceId != deviceId) {
            setDrivingId(0)
            setDeviceId(newDeviceId)
          }
          return
        }
        case "periodType": {
          setPeriodType(e.data.value)
          return
        }
        case "safetyScore": {
          setScore(data)
          return
        }
        case "driving": {
          return setDrivingId(data.drivingId)
        }
      }

    } catch (e: any) {
      console.error(`onEvent > `, e)
    }
  }

  if (isLoadingPage || !isAccessible) {
    return (
      <StyledPage className="contents_guard">
        {isLoadingPage ? (
          <p>{`페이지 로딩중입니다\n잠시만 기다려주세요`}</p>
        ) : !isAccessible ? (
          <p>{`금일은 안전운행점수를 계산중에있어 내용 확인이 불가능합니다`}</p>
        ) : null}
      </StyledPage>
    )
  }

  return (
    <StyledPage>
      <Section_History_Targets onEvent={onEvent} />

      <section className="contents">
        <Section_History_Header />
        <Section_History_SafetyScore score={score} />
        <Section_History_PeriodAverage deviceId={deviceId} periodType={periodType} date={date} onEvent={onEvent} />
        <Section_History_Calendar deviceId={deviceId} date={date} setDate={setDate} />
        <Section_History_DailyDrivings apiParams={dailyDrivingListParams} drivingId={drivingId} date={date} onEvent={onEvent} />
        <Section_History_DrivingDetails apiParams={drivingDetailParams} />
        <Section_History_Googlemap apiParams={drivingDetailParams} />
      </section>
    </StyledPage>
  )
}

export const StyledPage = styled.div`
  flex: 1;
  background-color: ${theme.colors.black_bg2};
  
  &.contents_guard {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: ${theme.colors.white};
    font-size: 18px;
    white-space: pre-wrap;
  }
  & > .contents {
    position: fixed;
    bottom: 0;
    right: 0;
    width: calc(100% - 400px);
    height: calc(100% - 65px);
    overflow: auto;
    display: grid;
    grid-template-columns: 280px 270px 1fr;
    grid-template-rows: 60px min-content 315px minmax(600px, 1fr);
    gap: 14px;
    padding: 14px;
    color: ${theme.colors.white};

    & > section {
      display: grid;
      background-color: ${theme.colors.black_bg};
      border-radius: 8px;
      padding: 10px;
      overflow: hidden;
      min-width: min-content;

      & > header {
        display: flex;
        justify-content: space-between;
        gap: 10px;

        & > label {
          font-size: 18px;
          font-weight: 600;
        }
        & > strong {
          color: ${theme.colors.yellowgreen};
        }
      }

      &.Header {
        grid-area: 1 / 1 / 2 / 4;
      }
      &.SafetyScore {
        grid-area: 2 / 1 / 3 / 2;
      }
      &.PeriodAverage {
        grid-area: 2 / 2 / 3 / 4;
      }
      &.Calendar {
        grid-area: 3 / 1 / 4 / 2;
        padding: 0;
      }
      &.DailyList {
        grid-area: 3 / 2 / 4 / 3;
      }
      &.DailyDetails {
        grid-area: 3 / 3 / 4 / 4;
      }
      &.Googlemap {
        grid-area: 4 / 1 / 5 / 4;
      }
    }
  }
`

const Sections_SafeScore = () => {
  return (
    <>
    </>
  )
}